<template>
    <div class="index">
        <div class="helloOther">
            <div class="helloOtherDiv">
                <!-- header头部 -->
                <div class="title">
                    <div class="titleDiv">
                        <ul>
                            <li><img src="../assets/images/logo.png" alt=""><em>2019年中国北京世界园艺博览会</em></li>
                        </ul>
                    </div>
                </div>
                <!-- 中间 -->
                <div class="cont">
                    <div class="div">
                        <div class="div1">票务系统温馨提示：</div>
                        <div style="text-indent:2em;">为了更好保障票务系统安全可靠运行，每晚03:00-04:00系统暂停服务一小时，给您带来的不便敬请谅解！</div>
                        <!-- <div class="div2">升级后将恢复正常访问，敬请期待...</div> -->
                    </div>
                </div>
                <!-- 页尾 -->
                <div class="footer">
                    <div class="footerDiv">
                        <div class="left">
                            <span>版权所有：2019中国北京世界园艺博览会</span>
                            <span>联系电话：010-86484017</span>
                            <br>
                            <span>地址：北京市石景山区阜石路159号首钢体育大厦</span>
                            <span>邮政编码：100043</span>
                            <br>
                        </div>
                        <div class="right">
                            <div style="margin-left:10px">
                                <img src="../assets/images/wx.jpg" alt="">
                                <p>官方微信</p>
                            </div>
                            <!-- <div style="margin-left:10px">
                                <img src="../assets/images/wx.jpg" alt="">
                                <p>官方微博</p>
                            </div> -->
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    export default {
        data() {
            return {
               
            }
        },
    }
</script>

<style scoped>
    .index{
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
    }
    ul,li{
        margin: 0;
        padding: 0;
        list-style: none;
    }
    i,em{
        font-style: normal;
    }
    .helloOther{
        margin: 0 auto;
        width: 100%;
        height: 100%;
    }
    .helloOtherDiv{
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;
    }
    .helloOtherDiv .title{
        z-index: 10;
        background-color: #16365c;
        color: #fff;
        font-size: 18px;
        height: 100px;
        line-height: 100px;
        width: 100%;
    }
    .helloOtherDiv .titleDiv{
            width: 1200px;
            height: 100%;
            margin: 0 auto;
    }
    .helloOtherDiv .titleDiv li{
        float: left;
        cursor: pointer;
        font-size: 22px;
                    
    }
    .helloOtherDiv .titleDiv li img{
        margin: 13px 46px 0 0;
        float: left;
    }
    .helloOtherDiv .cont{
        flex: 1;
        width: 100%;
        height: 100%;
        position: relative;
        background: #16365C;
    }
    .helloOtherDiv .div{
        font-size: 18px;
        text-align: left;
        color: #fff;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        position: absolute;
    }
    .helloOtherDiv .div>div{
        font-size: 21px;
        /* margin-bottom : 20px ; */
        line-height: 2;
    }
    .helloOtherDiv .div1{
        margin-bottom : 20px ;
    }
    .footer{
        background-color: #16365C;
        position: relative;
        z-index: 2;
        width: 100%;
        color: #fff;
    }
    .footerDiv{
        box-sizing: border-box;
        width: 1200px;
        height: 280px;
        margin: 0 auto;
        font-size: 14px;
    }
    .footer .left{
        float: left;
        padding-top: 103px;
    }
    .footerDiv span{
        margin: 0 14px 25px 0;
        display: inline-block;
    }
    .footerDiv .right{
        float: right;
        padding-top: 53px;
        text-align: center;
    }
    .footerDiv .right>div{
        float: left;
        margin-left: 33px;
    }
    .footerDiv .right>div p{
        margin-top: 10px;
    }
    .footerDiv .right>div img{
        width: 136px;
    }
</style>


// WEBPACK FOOTER //
// src/views/Others.vue